import { OptimizedImage } from "@/components/OptimizedImage";
import forbesLogo from "@/assets/forbes-logo.webp";
import beltAward1 from "@/assets/awards/belt-2021-haymarket.webp";
import beltAward2 from "@/assets/awards/belt-2022-fauquier.webp";
import beltAward3 from "@/assets/awards/belt-2023-haymarket.webp";
import beltAward4 from "@/assets/awards/belt-2024-haymarket.webp";
import beltAward5 from "@/assets/awards/belt-2025-haymarket.webp";
import beltAward6 from "@/assets/awards/belt-2022-prince-william.webp";
import beltAward7 from "@/assets/awards/belt-2023-prince-william.webp";
import beltAward8 from "@/assets/awards/belt-2024-prince-william.webp";
import beltAward9 from "@/assets/awards/belt-2025-prince-william.webp";

const awardImages = [
  { src: beltAward1, alt: "Best of Haymarket 2021 award" },
  { src: beltAward2, alt: "Best of Fauquier 2022 award" },
  { src: beltAward3, alt: "Best of Haymarket 2023 award" },
  { src: beltAward4, alt: "Best of Haymarket 2024 award" },
  { src: beltAward5, alt: "Best of Haymarket 2025 award" },
  { src: beltAward6, alt: "Best of Prince William 2022 award" },
  { src: beltAward7, alt: "Best of Prince William 2023 award" },
  { src: beltAward8, alt: "Best of Prince William 2024 award" },
  { src: beltAward9, alt: "Best of Prince William 2025 award" },
];

const AwardBelt = () => (
  <div className="flex items-center gap-8 shrink-0 pr-8">
    {awardImages.map((award, i) => (
      <OptimizedImage
        key={i}
        src={award.src}
        alt={award.alt}
        className="h-28 md:h-36 mix-blend-multiply"
        width={144}
        height={144}
      />
    ))}
  </div>
);

export const AsSeenIn = () => {
  return (
    <section className="pt-0 pb-4 md:pt-0 md:pb-6" style={{
      backgroundColor: 'hsl(40 30% 97%)'
    }}>
      <div className="container mx-auto px-4 text-center">
        <p className="text-sm text-black/50 uppercase tracking-widest mb-4">As Seen In</p>
        <a 
          href="https://www.forbes.com/sites/elizabethmacbride/2025/12/31/why-smart-entrepreneurs-need-to-consider-debt-and-taxes-in-2025-26/?utm_source=chatgpt.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="inline-block hover:opacity-80 transition-opacity"
        >
          <OptimizedImage
            src={forbesLogo}
            alt="As seen in Forbes"
            className="h-16 md:h-20 mx-auto"
            width={200}
            height={80}
            sizes="(max-width: 768px) 160px, 200px"
          />
        </a>
        
        {/* Awards Belt - Scrolling Marquee */}
        <div className="mt-6 overflow-hidden">
          <div className="flex animate-marquee-left">
            <AwardBelt />
            <AwardBelt />
          </div>
        </div>
      </div>
    </section>
  );
};
